import React, { useEffect } from 'react'
import './videoPlayer.css'
import { useOutsideClick } from 'Hooks'

const VideoPlayer = ({ onClose, videoId }) => {
   const ref = useOutsideClick(() => onClose())
   useEffect(() => {
      document.body.style.overflow = 'hidden'
      return () => {
         document.body.style.overflow = 'auto'
      }
   }, [])

   const onCloseModal = () => {
      onClose()
      document.body.style.overflow = 'auto'
   }

   return (
      <div>
         <div className="cs-modal-overlay">
            <div className="cs-modal">
               <button className="cs-modal-close-button" onClick={onCloseModal}>
                  ×
               </button>
               <div className="cs-modal-content" ref={ref}>
                  <div
                     style={{
                        position: 'relative',
                        paddingBottom: '56.25%',
                        height: 0
                     }}>
                     <iframe
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Atenya"
                        style={{
                           position: 'absolute',
                           top: 0,
                           left: 0,
                           width: '100%',
                           height: '100%'
                        }}></iframe>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default VideoPlayer
